
import React from 'react';
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface StatItemProps {
  icon: LucideIcon;
  value: number | string; // Updated to allow string values
  label: string;
  className?: string;
  iconClassName?: string;
  valueClassName?: string;
  labelClassName?: string;
}

const StatItem: React.FC<StatItemProps> = ({
  icon: Icon,
  value,
  label,
  className,
  iconClassName,
  valueClassName,
  labelClassName,
}) => {
  return (
    <div className={cn("flex flex-col items-center", className)}>
      <div className={cn("w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 text-primary", iconClassName)}>
        <Icon className="h-4 w-4" />
      </div>
      <p className={cn("text-xl font-bold mt-2", valueClassName)}>{value}</p>
      <p className={cn("text-xs text-muted-foreground", labelClassName)}>{label}</p>
    </div>
  );
};

export default StatItem;
